export function getTailwindBgColours() {
    return [
        {
            paletteName: "gray",
            swatches: [
                {
                    name: "bg-gray-100",
                    hex: "#f7fafc",
                },
                {
                    name: "bg-gray-200",
                    hex: "#edf2f7",
                },
                {
                    name: "bg-gray-300",
                    hex: "#e2e8f0",
                },
                {
                    name: "bg-gray-400",
                    hex: "#cbd5e0",
                },
                {
                    name: "bg-gray-500",
                    hex: "#a0aec0",
                },
                {
                    name: "bg-gray-600",
                    hex: "#718096",
                },
                {
                    name: "bg-gray-700",
                    hex: "#4a5568",
                },
                {
                    name: "bg-gray-800",
                    hex: "#2d3748",
                },
                {
                    name: "bg-gray-900",
                    hex: "#1a202c",
                },
            ],
        },
        {
            paletteName: "slate",
            swatches: [
                {
                    name: "bg-slate-50",
                    hex: "#f8fafc",
                },
                {
                    name: "bg-slate-100",
                    hex: "#f1f5f9",
                },
                {
                    name: "bg-slate-200",
                    hex: "#e2e8f0",
                },
                {
                    name: "bg-slate-300",
                    hex: "#cbd5e0",
                },
                {
                    name: "bg-slate-400",
                    hex: "#94a3b8",
                },
                {
                    name: "bg-slate-500",
                    hex: "#64748b",
                },
                {
                    name: "bg-slate-600",
                    hex: "#475569",
                },
                {
                    name: "bg-slate-700",
                    hex: "#334155",
                },
                {
                    name: "bg-slate-800",
                    hex: "#1e293b",
                },
                {
                    name: "bg-slate-900",
                    hex: "#0f172a",
                },
                {
                    name: "bg-slate-950",
                    hex: "#020617",
                },
            ],
        },
        {
            paletteName: "zinc",
            swatches: [
                {
                    name: "bg-zinc-50",
                    hex: "#fafafa",
                },
                {
                    name: "bg-zinc-100",
                    hex: "#f4f4f5",
                },
                {
                    name: "bg-zinc-200",
                    hex: "#e4e4e7",
                },
                {
                    name: "bg-zinc-300",
                    hex: "#d4d4d8",
                },
                {
                    name: "bg-zinc-400",
                    hex: "#a1a1aa",
                },
                {
                    name: "bg-zinc-500",
                    hex: "#71717a",
                },
                {
                    name: "bg-zinc-600",
                    hex: "#52525b",
                },
                {
                    name: "bg-zinc-700",
                    hex: "#3f3f46",
                },
                {
                    name: "bg-zinc-800",
                    hex: "#27272a",
                },
                {
                    name: "bg-zinc-900",
                    hex: "#18181b",
                },
                {
                    name: "bg-zinc-950",
                    hex: "#09090b",
                }
            ],
        },
        {
            paletteName: "red",
            swatches: [
                {
                    name: "bg-red-100",
                    hex: "#fff5f5",
                },
                {
                    name: "bg-red-200",
                    hex: "#fed7d7",
                },
                {
                    name: "bg-red-300",
                    hex: "#feb2b2",
                },
                {
                    name: "bg-red-400",
                    hex: "#fc8181",
                },
                {
                    name: "bg-red-500",
                    hex: "#f56565",
                },
                {
                    name: "bg-red-600",
                    hex: "#e53e3e",
                },
                {
                    name: "bg-red-700",
                    hex: "#c53030",
                },
                {
                    name: "bg-red-800",
                    hex: "#9b2c2c",
                },
                {
                    name: "bg-red-900",
                    hex: "#742a2a",
                },
            ],
        },
        {
            paletteName: "orange",
            swatches: [
                {
                    name: "bg-orange-100",
                    hex: "#fffaf0",
                },
                {
                    name: "bg-orange-200",
                    hex: "#feebc8",
                },
                {
                    name: "bg-orange-300",
                    hex: "#fbd38d",
                },
                {
                    name: "bg-orange-400",
                    hex: "#f6ad55",
                },
                {
                    name: "bg-orange-500",
                    hex: "#ed8936",
                },
                {
                    name: "bg-orange-600",
                    hex: "#dd6b20",
                },
                {
                    name: "bg-orange-700",
                    hex: "#c05621",
                },
                {
                    name: "bg-orange-800",
                    hex: "#9c4221",
                },
                {
                    name: "bg-orange-900",
                    hex: "#7b341e",
                },
            ],
        },
        {
            paletteName: "yellow",
            swatches: [
                {
                    name: "bg-yellow-100",
                    hex: "#fffff0",
                },
                {
                    name: "bg-yellow-200",
                    hex: "#fefcbf",
                },
                {
                    name: "bg-yellow-300",
                    hex: "#faf089",
                },
                {
                    name: "bg-yellow-400",
                    hex: "#f6e05e",
                },
                {
                    name: "bg-yellow-500",
                    hex: "#ecc94b",
                },
                {
                    name: "bg-yellow-600",
                    hex: "#d69e2e",
                },
                {
                    name: "bg-yellow-700",
                    hex: "#b7791f",
                },
                {
                    name: "bg-yellow-800",
                    hex: "#975a16",
                },
                {
                    name: "bg-yellow-900",
                    hex: "#744210",
                },
            ],
        },
        {
            paletteName: "green",
            swatches: [
                {
                    name: "bg-green-100",
                    hex: "#f0fff4",
                },
                {
                    name: "bg-green-200",
                    hex: "#c6f6d5",
                },
                {
                    name: "bg-green-300",
                    hex: "#9ae6b4",
                },
                {
                    name: "bg-green-400",
                    hex: "#68d391",
                },
                {
                    name: "bg-green-500",
                    hex: "#48bb78",
                },
                {
                    name: "bg-green-600",
                    hex: "#38a169",
                },
                {
                    name: "bg-green-700",
                    hex: "#2f855a",
                },
                {
                    name: "bg-green-800",
                    hex: "#276749",
                },
                {
                    name: "bg-green-900",
                    hex: "#22543d",
                },
            ],
        },
        {
            paletteName: "teal",
            swatches: [
                {
                    name: "bg-teal-100",
                    hex: "#e6fffa",
                },
                {
                    name: "bg-teal-200",
                    hex: "#b2f5ea",
                },
                {
                    name: "bg-teal-300",
                    hex: "#81e6d9",
                },
                {
                    name: "bg-teal-400",
                    hex: "#4fd1c5",
                },
                {
                    name: "bg-teal-500",
                    hex: "#38b2ac",
                },
                {
                    name: "bg-teal-600",
                    hex: "#319795",
                },
                {
                    name: "bg-teal-700",
                    hex: "#2c7a7b",
                },
                {
                    name: "bg-teal-800",
                    hex: "#285e61",
                },
                {
                    name: "bg-teal-900",
                    hex: "#234e52",
                },
            ],
        },
        {
            paletteName: "blue",
            swatches: [
                {
                    name: "bg-blue-100",
                    hex: "#ebf8ff",
                },
                {
                    name: "bg-blue-200",
                    hex: "#bee3f8",
                },
                {
                    name: "bg-blue-300",
                    hex: "#90cdf4",
                },
                {
                    name: "bg-blue-400",
                    hex: "#63b3ed",
                },
                {
                    name: "bg-blue-500",
                    hex: "#4299e1",
                },
                {
                    name: "bg-blue-600",
                    hex: "#3182ce",
                },
                {
                    name: "bg-blue-700",
                    hex: "#2b6cb0",
                },
                {
                    name: "bg-blue-800",
                    hex: "#2c5282",
                },
                {
                    name: "bg-blue-900",
                    hex: "#2a4365",
                },
            ],
        },
        {
            paletteName: "indigo",
            swatches: [
                {
                    name: "bg-indigo-100",
                    hex: "#ebf4ff",
                },
                {
                    name: "bg-indigo-200",
                    hex: "#c3dafe",
                },
                {
                    name: "bg-indigo-300",
                    hex: "#a3bffa",
                },
                {
                    name: "bg-indigo-400",
                    hex: "#7f9cf5",
                },
                {
                    name: "bg-indigo-500",
                    hex: "#667eea",
                },
                {
                    name: "bg-indigo-600",
                    hex: "#5a67d8",
                },
                {
                    name: "bg-indigo-700",
                    hex: "#4c51bf",
                },
                {
                    name: "bg-indigo-800",
                    hex: "#434190",
                },
                {
                    name: "bg-indigo-900",
                    hex: "#3c366b",
                },
            ],
        },
        {
            paletteName: "purple",
            swatches: [
                {
                    name: "bg-purple-100",
                    hex: "#faf5ff",
                },
                {
                    name: "bg-purple-200",
                    hex: "#e9d8fd",
                },
                {
                    name: "bg-purple-300",
                    hex: "#d6bcfa",
                },
                {
                    name: "bg-purple-400",
                    hex: "#b794f4",
                },
                {
                    name: "bg-purple-500",
                    hex: "#9f7aea",
                },
                {
                    name: "bg-purple-600",
                    hex: "#805ad5",
                },
                {
                    name: "bg-purple-700",
                    hex: "#6b46c1",
                },
                {
                    name: "bg-purple-800",
                    hex: "#553c9a",
                },
                {
                    name: "bg-purple-900",
                    hex: "#44337a",
                },
            ],
        },
        {
            paletteName: "pink",
            swatches: [
                {
                    name: "bg-pink-100",
                    hex: "#fff5f7",
                },
                {
                    name: "bg-pink-200",
                    hex: "#fed7e2",
                },
                {
                    name: "bg-pink-300",
                    hex: "#fbb6ce",
                },
                {
                    name: "bg-pink-400",
                    hex: "#f687b3",
                },
                {
                    name: "bg-pink-500",
                    hex: "#ed64a6",
                },
                {
                    name: "bg-pink-600",
                    hex: "#d53f8c",
                },
                {
                    name: "bg-pink-700",
                    hex: "#b83280",
                },
                {
                    name: "bg-pink-800",
                    hex: "#97266d",
                },
                {
                    name: "bg-pink-900",
                    hex: "#702459",
                },
            ],
        },
    ];
}

export function getTailwindTextColours() {
    return [
        {
            paletteName: "gray",
            swatches: [
                {
                    name: "text-gray-100",
                    hex: "#f7fafc",
                },
                {
                    name: "text-gray-200",
                    hex: "#edf2f7",
                },
                {
                    name: "text-gray-300",
                    hex: "#e2e8f0",
                },
                {
                    name: "text-gray-400",
                    hex: "#cbd5e0",
                },
                {
                    name: "text-gray-500",
                    hex: "#a0aec0",
                },
                {
                    name: "text-gray-600",
                    hex: "#718096",
                },
                {
                    name: "text-gray-700",
                    hex: "#4a5568",
                },
                {
                    name: "text-gray-800",
                    hex: "#2d3748",
                },
                {
                    name: "text-gray-900",
                    hex: "#1a202c",
                },
            ],
        },
        {
            paletteName: "slate",
            swatches: [
                {
                    name: "text-slate-50",
                    hex: "#f8fafc",
                },
                {
                    name: "text-slate-100",
                    hex: "#f1f5f9",
                },
                {
                    name: "text-slate-200",
                    hex: "#e2e8f0",
                },
                {
                    name: "text-slate-300",
                    hex: "#cbd5e0",
                },
                {
                    name: "text-slate-400",
                    hex: "#94a3b8",
                },
                {
                    name: "text-slate-500",
                    hex: "#64748b",
                },
                {
                    name: "text-slate-600",
                    hex: "#475569",
                },
                {
                    name: "text-slate-700",
                    hex: "#334155",
                },
                {
                    name: "text-slate-800",
                    hex: "#1e293b",
                },
                {
                    name: "text-slate-900",
                    hex: "#0f172a",
                },
                {
                    name: "text-slate-950",
                    hex: "#020617",
                },
            ],
        },
        {
            paletteName: "zinc",
            swatches: [
                {
                    name: "text-zinc-50",
                    hex: "#fafafa",
                },
                {
                    name: "text-zinc-100",
                    hex: "#f4f4f5",
                },
                {
                    name: "text-zinc-200",
                    hex: "#e4e4e7",
                },
                {
                    name: "text-zinc-300",
                    hex: "#d4d4d8",
                },
                {
                    name: "text-zinc-400",
                    hex: "#a1a1aa",
                },
                {
                    name: "text-zinc-500",
                    hex: "#71717a",
                },
                {
                    name: "text-zinc-600",
                    hex: "#52525b",
                },
                {
                    name: "text-zinc-700",
                    hex: "#3f3f46",
                },
                {
                    name: "text-zinc-800",
                    hex: "#27272a",
                },
                {
                    name: "text-zinc-900",
                    hex: "#18181b",
                },
                {
                    name: "text-zinc-950",
                    hex: "#09090b",
                }
            ],
        },
        {
            paletteName: "red",
            swatches: [
                {
                    name: "text-red-100",
                    hex: "#fff5f5",
                },
                {
                    name: "text-red-200",
                    hex: "#fed7d7",
                },
                {
                    name: "text-red-300",
                    hex: "#feb2b2",
                },
                {
                    name: "text-red-400",
                    hex: "#fc8181",
                },
                {
                    name: "text-red-500",
                    hex: "#f56565",
                },
                {
                    name: "text-red-600",
                    hex: "#e53e3e",
                },
                {
                    name: "text-red-700",
                    hex: "#c53030",
                },
                {
                    name: "text-red-800",
                    hex: "#9b2c2c",
                },
                {
                    name: "text-red-900",
                    hex: "#742a2a",
                },
            ],
        },
        {
            paletteName: "orange",
            swatches: [
                {
                    name: "text-orange-100",
                    hex: "#fffaf0",
                },
                {
                    name: "text-orange-200",
                    hex: "#feebc8",
                },
                {
                    name: "text-orange-300",
                    hex: "#fbd38d",
                },
                {
                    name: "text-orange-400",
                    hex: "#f6ad55",
                },
                {
                    name: "text-orange-500",
                    hex: "#ed8936",
                },
                {
                    name: "text-orange-600",
                    hex: "#dd6b20",
                },
                {
                    name: "text-orange-700",
                    hex: "#c05621",
                },
                {
                    name: "text-orange-800",
                    hex: "#9c4221",
                },
                {
                    name: "text-orange-900",
                    hex: "#7b341e",
                },
            ],
        },
        {
            paletteName: "yellow",
            swatches: [
                {
                    name: "text-yellow-100",
                    hex: "#fffff0",
                },
                {
                    name: "text-yellow-200",
                    hex: "#fefcbf",
                },
                {
                    name: "text-yellow-300",
                    hex: "#faf089",
                },
                {
                    name: "text-yellow-400",
                    hex: "#f6e05e",
                },
                {
                    name: "text-yellow-500",
                    hex: "#ecc94b",
                },
                {
                    name: "text-yellow-600",
                    hex: "#d69e2e",
                },
                {
                    name: "text-yellow-700",
                    hex: "#b7791f",
                },
                {
                    name: "text-yellow-800",
                    hex: "#975a16",
                },
                {
                    name: "text-yellow-900",
                    hex: "#744210",
                },
            ],
        },
        {
            paletteName: "green",
            swatches: [
                {
                    name: "text-green-100",
                    hex: "#f0fff4",
                },
                {
                    name: "text-green-200",
                    hex: "#c6f6d5",
                },
                {
                    name: "text-green-300",
                    hex: "#9ae6b4",
                },
                {
                    name: "text-green-400",
                    hex: "#68d391",
                },
                {
                    name: "text-green-500",
                    hex: "#48bb78",
                },
                {
                    name: "text-green-600",
                    hex: "#38a169",
                },
                {
                    name: "text-green-700",
                    hex: "#2f855a",
                },
                {
                    name: "text-green-800",
                    hex: "#276749",
                },
                {
                    name: "text-green-900",
                    hex: "#22543d",
                },
            ],
        },
        {
            paletteName: "teal",
            swatches: [
                {
                    name: "text-teal-100",
                    hex: "#e6fffa",
                },
                {
                    name: "text-teal-200",
                    hex: "#b2f5ea",
                },
                {
                    name: "text-teal-300",
                    hex: "#81e6d9",
                },
                {
                    name: "text-teal-400",
                    hex: "#4fd1c5",
                },
                {
                    name: "text-teal-500",
                    hex: "#38b2ac",
                },
                {
                    name: "text-teal-600",
                    hex: "#319795",
                },
                {
                    name: "text-teal-700",
                    hex: "#2c7a7b",
                },
                {
                    name: "text-teal-800",
                    hex: "#285e61",
                },
                {
                    name: "text-teal-900",
                    hex: "#234e52",
                },
            ],
        },
        {
            paletteName: "blue",
            swatches: [
                {
                    name: "text-blue-100",
                    hex: "#ebf8ff",
                },
                {
                    name: "text-blue-200",
                    hex: "#bee3f8",
                },
                {
                    name: "text-blue-300",
                    hex: "#90cdf4",
                },
                {
                    name: "text-blue-400",
                    hex: "#63b3ed",
                },
                {
                    name: "text-blue-500",
                    hex: "#4299e1",
                },
                {
                    name: "text-blue-600",
                    hex: "#3182ce",
                },
                {
                    name: "text-blue-700",
                    hex: "#2b6cb0",
                },
                {
                    name: "text-blue-800",
                    hex: "#2c5282",
                },
                {
                    name: "text-blue-900",
                    hex: "#2a4365",
                },
            ],
        },
        {
            paletteName: "indigo",
            swatches: [
                {
                    name: "text-indigo-100",
                    hex: "#ebf4ff",
                },
                {
                    name: "text-indigo-200",
                    hex: "#c3dafe",
                },
                {
                    name: "text-indigo-300",
                    hex: "#a3bffa",
                },
                {
                    name: "text-indigo-400",
                    hex: "#7f9cf5",
                },
                {
                    name: "text-indigo-500",
                    hex: "#667eea",
                },
                {
                    name: "text-indigo-600",
                    hex: "#5a67d8",
                },
                {
                    name: "text-indigo-700",
                    hex: "#4c51bf",
                },
                {
                    name: "text-indigo-800",
                    hex: "#434190",
                },
                {
                    name: "text-indigo-900",
                    hex: "#3c366b",
                },
            ],
        },
        {
            paletteName: "purple",
            swatches: [
                {
                    name: "text-purple-100",
                    hex: "#faf5ff",
                },
                {
                    name: "text-purple-200",
                    hex: "#e9d8fd",
                },
                {
                    name: "text-purple-300",
                    hex: "#d6bcfa",
                },
                {
                    name: "text-purple-400",
                    hex: "#b794f4",
                },
                {
                    name: "text-purple-500",
                    hex: "#9f7aea",
                },
                {
                    name: "text-purple-600",
                    hex: "#805ad5",
                },
                {
                    name: "text-purple-700",
                    hex: "#6b46c1",
                },
                {
                    name: "text-purple-800",
                    hex: "#553c9a",
                },
                {
                    name: "text-purple-900",
                    hex: "#44337a",
                },
            ],
        },
        {
            paletteName: "pink",
            swatches: [
                {
                    name: "text-pink-100",
                    hex: "#fff5f7",
                },
                {
                    name: "text-pink-200",
                    hex: "#fed7e2",
                },
                {
                    name: "text-pink-300",
                    hex: "#fbb6ce",
                },
                {
                    name: "text-pink-400",
                    hex: "#f687b3",
                },
                {
                    name: "text-pink-500",
                    hex: "#ed64a6",
                },
                {
                    name: "text-pink-600",
                    hex: "#d53f8c",
                },
                {
                    name: "text-pink-700",
                    hex: "#b83280",
                },
                {
                    name: "text-pink-800",
                    hex: "#97266d",
                },
                {
                    name: "text-pink-900",
                    hex: "#702459",
                },
            ],
        },
    ];
}

export function getTailwindBorderColours() {
    return [
        {
            paletteName: "gray",
            swatches: [
                {
                    name: "border-gray-100",
                    hex: "#f7fafc",
                },
                {
                    name: "border-gray-200",
                    hex: "#edf2f7",
                },
                {
                    name: "border-gray-300",
                    hex: "#e2e8f0",
                },
                {
                    name: "border-gray-400",
                    hex: "#cbd5e0",
                },
                {
                    name: "border-gray-500",
                    hex: "#a0aec0",
                },
                {
                    name: "border-gray-600",
                    hex: "#718096",
                },
                {
                    name: "border-gray-700",
                    hex: "#4a5568",
                },
                {
                    name: "border-gray-800",
                    hex: "#2d3748",
                },
                {
                    name: "border-gray-900",
                    hex: "#1a202c",
                },
            ],
        },
        {
            paletteName: "slate",
            swatches: [
                {
                    name: "border-slate-50",
                    hex: "#f8fafc",
                },
                {
                    name: "border-slate-100",
                    hex: "#f1f5f9",
                },
                {
                    name: "border-slate-200",
                    hex: "#e2e8f0",
                },
                {
                    name: "border-slate-300",
                    hex: "#cbd5e0",
                },
                {
                    name: "border-slate-400",
                    hex: "#94a3b8",
                },
                {
                    name: "border-slate-500",
                    hex: "#64748b",
                },
                {
                    name: "border-slate-600",
                    hex: "#475569",
                },
                {
                    name: "border-slate-700",
                    hex: "#334155",
                },
                {
                    name: "border-slate-800",
                    hex: "#1e293b",
                },
                {
                    name: "border-slate-900",
                    hex: "#0f172a",
                },
                {
                    name: "border-slate-950",
                    hex: "#020617",
                },
            ],
        },
        {
            paletteName: "zinc",
            swatches: [
                {
                    name: "border-zinc-50",
                    hex: "#fafafa",
                },
                {
                    name: "border-zinc-100",
                    hex: "#f4f4f5",
                },
                {
                    name: "border-zinc-200",
                    hex: "#e4e4e7",
                },
                {
                    name: "border-zinc-300",
                    hex: "#d4d4d8",
                },
                {
                    name: "border-zinc-400",
                    hex: "#a1a1aa",
                },
                {
                    name: "border-zinc-500",
                    hex: "#71717a",
                },
                {
                    name: "border-zinc-600",
                    hex: "#52525b",
                },
                {
                    name: "border-zinc-700",
                    hex: "#3f3f46",
                },
                {
                    name: "border-zinc-800",
                    hex: "#27272a",
                },
                {
                    name: "border-zinc-900",
                    hex: "#18181b",
                },
                {
                    name: "border-zinc-950",
                    hex: "#09090b",
                }
            ],
        },
        {
            paletteName: "red",
            swatches: [
                {
                    name: "border-red-100",
                    hex: "#fff5f5",
                },
                {
                    name: "border-red-200",
                    hex: "#fed7d7",
                },
                {
                    name: "border-red-300",
                    hex: "#feb2b2",
                },
                {
                    name: "border-red-400",
                    hex: "#fc8181",
                },
                {
                    name: "border-red-500",
                    hex: "#f56565",
                },
                {
                    name: "border-red-600",
                    hex: "#e53e3e",
                },
                {
                    name: "border-red-700",
                    hex: "#c53030",
                },
                {
                    name: "border-red-800",
                    hex: "#9b2c2c",
                },
                {
                    name: "border-red-900",
                    hex: "#742a2a",
                },
            ],
        },
        {
            paletteName: "orange",
            swatches: [
                {
                    name: "border-orange-100",
                    hex: "#fffaf0",
                },
                {
                    name: "border-orange-200",
                    hex: "#feebc8",
                },
                {
                    name: "border-orange-300",
                    hex: "#fbd38d",
                },
                {
                    name: "border-orange-400",
                    hex: "#f6ad55",
                },
                {
                    name: "border-orange-500",
                    hex: "#ed8936",
                },
                {
                    name: "border-orange-600",
                    hex: "#dd6b20",
                },
                {
                    name: "border-orange-700",
                    hex: "#c05621",
                },
                {
                    name: "border-orange-800",
                    hex: "#9c4221",
                },
                {
                    name: "border-orange-900",
                    hex: "#7b341e",
                },
            ],
        },
        {
            paletteName: "yellow",
            swatches: [
                {
                    name: "border-yellow-100",
                    hex: "#fffff0",
                },
                {
                    name: "border-yellow-200",
                    hex: "#fefcbf",
                },
                {
                    name: "border-yellow-300",
                    hex: "#faf089",
                },
                {
                    name: "border-yellow-400",
                    hex: "#f6e05e",
                },
                {
                    name: "border-yellow-500",
                    hex: "#ecc94b",
                },
                {
                    name: "border-yellow-600",
                    hex: "#d69e2e",
                },
                {
                    name: "border-yellow-700",
                    hex: "#b7791f",
                },
                {
                    name: "border-yellow-800",
                    hex: "#975a16",
                },
                {
                    name: "border-yellow-900",
                    hex: "#744210",
                },
            ],
        },
        {
            paletteName: "green",
            swatches: [
                {
                    name: "border-green-100",
                    hex: "#f0fff4",
                },
                {
                    name: "border-green-200",
                    hex: "#c6f6d5",
                },
                {
                    name: "border-green-300",
                    hex: "#9ae6b4",
                },
                {
                    name: "border-green-400",
                    hex: "#68d391",
                },
                {
                    name: "border-green-500",
                    hex: "#48bb78",
                },
                {
                    name: "border-green-600",
                    hex: "#38a169",
                },
                {
                    name: "border-green-700",
                    hex: "#2f855a",
                },
                {
                    name: "border-green-800",
                    hex: "#276749",
                },
                {
                    name: "border-green-900",
                    hex: "#22543d",
                },
            ],
        },
        {
            paletteName: "teal",
            swatches: [
                {
                    name: "border-teal-100",
                    hex: "#e6fffa",
                },
                {
                    name: "border-teal-200",
                    hex: "#b2f5ea",
                },
                {
                    name: "border-teal-300",
                    hex: "#81e6d9",
                },
                {
                    name: "border-teal-400",
                    hex: "#4fd1c5",
                },
                {
                    name: "border-teal-500",
                    hex: "#38b2ac",
                },
                {
                    name: "border-teal-600",
                    hex: "#319795",
                },
                {
                    name: "border-teal-700",
                    hex: "#2c7a7b",
                },
                {
                    name: "border-teal-800",
                    hex: "#285e61",
                },
                {
                    name: "border-teal-900",
                    hex: "#234e52",
                },
            ],
        },
        {
            paletteName: "blue",
            swatches: [
                {
                    name: "border-blue-100",
                    hex: "#ebf8ff",
                },
                {
                    name: "border-blue-200",
                    hex: "#bee3f8",
                },
                {
                    name: "border-blue-300",
                    hex: "#90cdf4",
                },
                {
                    name: "border-blue-400",
                    hex: "#63b3ed",
                },
                {
                    name: "border-blue-500",
                    hex: "#4299e1",
                },
                {
                    name: "border-blue-600",
                    hex: "#3182ce",
                },
                {
                    name: "border-blue-700",
                    hex: "#2b6cb0",
                },
                {
                    name: "border-blue-800",
                    hex: "#2c5282",
                },
                {
                    name: "border-blue-900",
                    hex: "#2a4365",
                },
            ],
        },
        {
            paletteName: "indigo",
            swatches: [
                {
                    name: "border-indigo-100",
                    hex: "#ebf4ff",
                },
                {
                    name: "border-indigo-200",
                    hex: "#c3dafe",
                },
                {
                    name: "border-indigo-300",
                    hex: "#a3bffa",
                },
                {
                    name: "border-indigo-400",
                    hex: "#7f9cf5",
                },
                {
                    name: "border-indigo-500",
                    hex: "#667eea",
                },
                {
                    name: "border-indigo-600",
                    hex: "#5a67d8",
                },
                {
                    name: "border-indigo-700",
                    hex: "#4c51bf",
                },
                {
                    name: "border-indigo-800",
                    hex: "#434190",
                },
                {
                    name: "border-indigo-900",
                    hex: "#3c366b",
                },
            ],
        },
        {
            paletteName: "purple",
            swatches: [
                {
                    name: "border-purple-100",
                    hex: "#faf5ff",
                },
                {
                    name: "border-purple-200",
                    hex: "#e9d8fd",
                },
                {
                    name: "border-purple-300",
                    hex: "#d6bcfa",
                },
                {
                    name: "border-purple-400",
                    hex: "#b794f4",
                },
                {
                    name: "border-purple-500",
                    hex: "#9f7aea",
                },
                {
                    name: "border-purple-600",
                    hex: "#805ad5",
                },
                {
                    name: "border-purple-700",
                    hex: "#6b46c1",
                },
                {
                    name: "border-purple-800",
                    hex: "#553c9a",
                },
                {
                    name: "border-purple-900",
                    hex: "#44337a",
                },
            ],
        },
        {
            paletteName: "pink",
            swatches: [
                {
                    name: "border-pink-100",
                    hex: "#fff5f7",
                },
                {
                    name: "border-pink-200",
                    hex: "#fed7e2",
                },
                {
                    name: "border-pink-300",
                    hex: "#fbb6ce",
                },
                {
                    name: "border-pink-400",
                    hex: "#f687b3",
                },
                {
                    name: "border-pink-500",
                    hex: "#ed64a6",
                },
                {
                    name: "border-pink-600",
                    hex: "#d53f8c",
                },
                {
                    name: "border-pink-700",
                    hex: "#b83280",
                },
                {
                    name: "border-pink-800",
                    hex: "#97266d",
                },
                {
                    name: "border-pink-900",
                    hex: "#702459",
                },
            ],
        },
    ];
}

export function getBorderRadius(value: number | string) {
    if(typeof value === "string") value = parseInt(value);
    switch (true) {
        case value === 0:
            return "rounded-none";
        case value > 0 && value < 5:
            return "rounded-sm";
        case value >= 5 && value < 10:
            return "rounded";
        case value >= 10 && value < 15:
            return "rounded-md";
        case value >= 15 && value < 20:
            return "rounded-lg";
        case value >= 20 && value < 25:
            return "rounded-xl";
        case value >= 25 && value < 30:
            return "rounded-2xl";
        case value >= 30 && value < 35:
            return "rounded-3xl";
        case value >= 35:
            return "rounded-full";
        default:
            return "rounded";
    }
}

export function getBorderWidth(value: number) {
    if (!value) {
        return "border-0";
    } else {
        const widths = ["border-0", "border-1", "border-2", "border-4"];
        return widths[value];
    }
}

export function getGridMaxCols(value: number) {
    if(value > 0 && value <= 10) {
        return `md:grid-cols-${value}`;
    } else {
        return "md:grid-cols-4";
    }
}

export function getDesktopColSpan(value: number, numberOfComponents: number) {
    if(numberOfComponents === 1) {
        return "md:col-span-full";
    } else if(value > 1 && value <= 10) {
        return `md:col-span-${value}`;
    } else {
        return "md:col-auto";
    }
}

// Function to get the gap between grid items in 5px increments
export function getGridGap(value: number) {
    if(value > 0 && value <= 50) {
        return `md:gap-[${value}px]`;
    } else {
        return "md:gap-[0px]";
    }
}

export function getMobileGridGap(value: number) {
    if(value > 0 && value <= 50) {
        return `gap-[${value}px]`;
    } else {
        return "gap-[0px]";
    }
}

export function getPadding(value: string, direction: string, desktop = false) {
    if(value) {
        return `${desktop ? "md:" : ""}p${direction}-[${value?.toString()?.replace('px', '')}px]`;
    } else {
        return `${desktop ? "md:" : ""}p${direction}-[0px]`;
    }
}

export function getMargin(value: string, direction: string, desktop = false) {

    if(value) {
        return `${desktop ? "md:" : ""}m${direction}-[${value?.toString()?.replace('px', '')}px]`;
    } else {
        return `${desktop ? "md:" : ""}m${direction}-[0px]`;
    }

}
